import {
  CopType,
  CurrencyCode,
  DropStatus,
  DropType,
  ItemRating,
  ItemResellAction,
  ItemStatus,
  ProductCategory,
  Region,
  ResellStore,
  SecuredServer,
  SiteType,
  UserSubscriptionProductType,
} from 'packlets/generated'

export const ENV = process.env.REACT_APP_ENV || ''
export const API_URL = process.env.REACT_APP_API_URL || ''
export const API_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID || ''
export const API_CLIENT_VERSION = process.env.REACT_APP_API_CLIENT_VERSION || ''
export const DISCORD_LOGIN_REDIRECT_URL =
  process.env.REACT_APP_DISCORD_LOGIN_REDIRECT_URL || ''
export const DISCORD_CHECKOUT_REDIRECT_URL =
  process.env.REACT_APP_DISCORD_CHECKOUT_REDIRECT_URL || ''
export const STRIPE_CHECKOUT_CANCEL_URL =
  process.env.REACT_APP_STRIPE_CHECKOUT_CANCEL_URL || ''
export const STRIPE_CHECKOUT_SUCCESS_URL =
  process.env.REACT_APP_STRIPE_CHECKOUT_SUCCESS_URL || ''
export const STRIPE_BILLING_PORTAL_REDIRECT_URL =
  process.env.REACT_APP_STRIPE_BILLING_PORTAL_REDIRECT_URL || ''

export const MIXPANEL_KEY = process.env.REACT_APP_MIXPANEL_KEY || ''
export const IP_API_KEY = process.env.REACT_APP_IP_API_KEY || ''
export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || ''
export const INTERCOM_CUSTOM_LAUNCHER_ID = 'secured_intercom_launcher'
export const FACEBOOK_PIXEL_KEY = process.env.REACT_APP_FACEBOOK_PIXEL_KEY || ''
export const APP_TWITTER_PIXEL_KEY =
  process.env.REACT_APP_TWITTER_PIXEL_KEY || ''

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || ''
export const SENTRY_DSN_WEB = process.env.REACT_APP_SENTRY_DSN_WEB || ''
export const SENTRY_DSN_APP = process.env.REACT_APP_SENTRY_DSN_APP || ''

export const DISCORD_SERVER_URL_EU =
  process.env.REACT_APP_DISCORD_SERVER_URL_EU || ''
export const DISCORD_SERVER_URL_US =
  process.env.REACT_APP_DISCORD_SERVER_URL_US || ''
export const DISCORD_SERVER_URL_NFT =
  process.env.REACT_APP_DISCORD_SERVER_URL_NFT || ''
export const DISCORD_SERVER_URL_POKEMON =
  process.env.REACT_APP_DISCORD_SERVER_URL_POKEMON || ''
export const DISCORD_SERVER_URL_CRYPTO =
  process.env.REACT_APP_DISCORD_SERVER_URL_CRYPTO || ''

export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDERID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
}

export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''

export const SNAPCHAT_PIXEL_KEY = process.env.REACT_APP_SNAPCHAT_PIXEL_KEY || ''

export const FALLBACK_IMAGE = '/images/placeholder-image.png'

export const PRODUCT_STATUS_TO_TEXT = {
  [ItemStatus.ComingSoon]: 'Coming Soon',
  [ItemStatus.Released]: 'Released',
}

export const PRODUCT_RESELL_ACTION_TO_TEXT = {
  [ItemResellAction.Hold]: 'Hold',
  [ItemResellAction.Sell]: 'Sell',
}

export const PRODUCT_RATING_TO_TEXT = {
  [ItemRating.Resell]: 'Resell',
  [ItemRating.PersonalPurchase]: 'Personal Purchase',
}

export const RESELL_STORE_TO_TEXT = {
  [ResellStore.Bump]: 'Bump',
  [ResellStore.Goat]: 'Goat',
  [ResellStore.Stockx]: 'StockX',
}

export const DROP_STATUS_TO_TEXT = {
  [DropStatus.InStock]: 'In Stock',
  [DropStatus.OutOfStock]: 'Out Of Stock',
  [DropStatus.ComingSoon]: 'Coming Soon',
}

export const DROP_TYPE_TO_TEXT = {
  [DropType.New]: 'New',
  [DropType.Restock]: 'Restock',
}

export const DROPS_COP_TYPE_STORAGE_KEY = 'DROPS_COP_TYPE'

export const RAFFLES_PRE_AUTH_STORAGE_KEY = 'RAFFLES_PRE_AUTH'

export const COP_TYPE_TO_TEXT = {
  [CopType.Manual]: 'Manual Focus',
  [CopType.Bot]: 'Bot Focus',
}

export const SITE_TYPE_TO_TEXT = {
  [SiteType.Custom]: 'Custom',
  [SiteType.Demandware]: 'Demandware',
  [SiteType.Footsite]: 'Footsite',
  [SiteType.Frenzy]: 'Frenzy',
  [SiteType.Magento]: 'Magento',
  [SiteType.Mesh]: 'Mesh',
  [SiteType.Prestashop]: 'Prestashop',
  [SiteType.Shopify]: 'Shopify',
  [SiteType.Snkrs]: 'SNKRS',
}

type RegionSymbolsType = {
  [key: string]: string
}

export const REGION_TO_TEXT: RegionSymbolsType = {
  [Region.Worldwide]: 'Worldwide',
  [Region.Europe]: 'EU',
  [Region.Uk]: 'UK',
  [Region.France]: 'France',
  [Region.Italy]: 'Italy',
  [Region.Germany]: 'Germany',
  [Region.Netherlands]: 'Netherlands',
  [Region.Spain]: 'Spain',
  [Region.Us]: 'US',
  [Region.Canada]: 'Canada',
}

export const REGION_TO_EMOJI: RegionSymbolsType = {
  [Region.Worldwide]: '🌎',
  [Region.Europe]: '🇪🇺',
  [Region.Uk]: '🇬🇧',
  [Region.France]: '🇫🇷',
  [Region.Italy]: '🇮🇹',
  [Region.Germany]: '🇩🇪',
  [Region.Netherlands]: '🇳🇱',
  [Region.Spain]: '🇪🇸',
  [Region.Us]: '🇺🇸',
  [Region.Canada]: '🇨🇦',
}

export const REGION_TO_COUNTRY_CODE: RegionSymbolsType = {
  [Region.Europe]: 'eu',
  [Region.Uk]: 'gb',
  [Region.France]: 'fr',
  [Region.Italy]: 'it',
  [Region.Germany]: 'de',
  [Region.Netherlands]: 'nl',
  [Region.Spain]: 'es',
  [Region.Us]: 'us',
  [Region.Canada]: 'ca',
}

export const REGION_STORAGE_KEY: string = 'REGION'

type CurrencySymbolsType = {
  [key in CurrencyCode]: string
}

export const CURRENCY_SYMBOLS: CurrencySymbolsType = {
  [CurrencyCode.Eur]: '€',
  [CurrencyCode.Gbp]: '£',
  [CurrencyCode.Usd]: '$',
}

interface CurrencyType {
  [key: string]: string
}

export const CURRENCY_TO_TEXT: CurrencyType = {
  [CurrencyCode.Eur]: 'EUR',
  [CurrencyCode.Gbp]: 'GBP',
  [CurrencyCode.Usd]: 'USD',
}

interface ServerType {
  [key: string]: string
}

export const SERVER_TO_TEXT: ServerType = {
  [SecuredServer.Eu]: 'EU',
  [SecuredServer.Us]: 'NA',
  [SecuredServer.Nft]: 'NFT',
  [SecuredServer.Pokemon]: 'Pokemon',
  [SecuredServer.Crypto]: 'Crypto',
}

export const USER_SUBSCRIPTION_PRODUCT_TYPE_TO_TEXT = {
  [UserSubscriptionProductType.Nft]: 'NFT',
  [UserSubscriptionProductType.Sneakers]: 'Sneakers',
  [UserSubscriptionProductType.SportsCards]: 'Sports Cards',
  [UserSubscriptionProductType.Pokemon]: 'Pokemon',
  [UserSubscriptionProductType.Crypto]: 'Crypto',
}

interface CoutryType {
  [key: string]: string
}

export const COUNTRIES: CoutryType = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua And Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia And Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, Democratic Republic',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Cote D'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island & Mcdonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic Of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle Of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyan Arab Jamahiriya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States Of',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena',
  KN: 'Saint Kitts And Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre And Miquelon',
  VC: 'Saint Vincent And Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome And Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia And Sandwich Isl.',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard And Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad And Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks And Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis And Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}

export const COUNTRIES_REVERSED: CoutryType = Object.keys(COUNTRIES).reduce(
  (acc, code) => {
    return { ...acc, [COUNTRIES[code]]: code }
  },
  {}
)

interface ProductCategoriesType {
  [key: string]: string
}

export const PRODUCT_CATEGORIES_TO_TEXT: ProductCategoriesType = {
  all: 'All',
  [ProductCategory.Footwear]: 'Footwear',
  [ProductCategory.Tops]: 'Tops',
  [ProductCategory.Bottoms]: 'Bottoms',
  [ProductCategory.Outerwear]: 'Outerwear',
  [ProductCategory.Accessories]: 'Accessories',
  [ProductCategory.Lifestyle]: 'Lifestyle',
}
